/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

export * from '@salesforce/retail-react-app/app/constants';

export const PRODUCT_TILE_DYNAMIC_IMAGE_PROPS = {
  widths: ['50vw', '50vw', '20vw', '20vw', '25vw'],
};
